// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  display: flex;
  min-height: 100vh;
  background-color: #f7fafc;
}

.sidebar {
  width: 260px;
  background: linear-gradient(180deg, #1a202c 0%, #2d3748 100%);
  color: white;
  display: flex;
  flex-direction: column;
  transition: width 0.3s ease;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
}

.sidebar.closed {
  width: 80px;
}

.sidebar-header {
  padding: 24px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.sidebar-header h2 {
  font-size: 20px;
  font-weight: 700;
  white-space: nowrap;
  opacity: 1;
  transition: opacity 0.3s;
}

.sidebar.closed .sidebar-header h2 {
  opacity: 0;
  width: 0;
  overflow: hidden;
}

.sidebar-toggle {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  font-size: 14px;
}

.sidebar-toggle:hover {
  background: rgba(255, 255, 255, 0.2);
}

.sidebar-nav {
  flex: 1;
  padding: 20px 0;
  overflow-y: auto;
}

.sidebar-nav ul {
  list-style: none;
  padding: 0;
}

.sidebar-nav li {
  margin: 4px 12px;
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  border-radius: 8px;
  transition: all 0.2s;
  font-size: 14px;
  font-weight: 500;
}

.nav-link:hover {
  background: rgba(255, 255, 255, 0.1);
  color: white;
}

.nav-link.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.nav-icon {
  font-size: 20px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-label {
  white-space: nowrap;
  opacity: 1;
  transition: opacity 0.3s;
}

.sidebar.closed .nav-label {
  opacity: 0;
  width: 0;
  overflow: hidden;
}

.sidebar-footer {
  padding: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.logout-button {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 8px;
  color: white;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.logout-button:hover {
  background: rgba(255, 255, 255, 0.2);
}

.sidebar.closed .logout-button span:not(:first-child) {
  opacity: 0;
  width: 0;
  overflow: hidden;
}

.dashboard-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.dashboard-header {
  background: white;
  padding: 24px 32px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  border-bottom: 1px solid #e2e8f0;
}

.dashboard-header h1 {
  font-size: 24px;
  font-weight: 700;
  color: #1a202c;
}

.dashboard-content {
  flex: 1;
  padding: 32px;
  overflow-y: auto;
}

`, "",{"version":3,"sources":["webpack://./src/components/DashboardLayout.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,OAAO;EACP,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB","sourcesContent":[".dashboard-container {\n  display: flex;\n  min-height: 100vh;\n  background-color: #f7fafc;\n}\n\n.sidebar {\n  width: 260px;\n  background: linear-gradient(180deg, #1a202c 0%, #2d3748 100%);\n  color: white;\n  display: flex;\n  flex-direction: column;\n  transition: width 0.3s ease;\n  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);\n}\n\n.sidebar.closed {\n  width: 80px;\n}\n\n.sidebar-header {\n  padding: 24px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.sidebar-header h2 {\n  font-size: 20px;\n  font-weight: 700;\n  white-space: nowrap;\n  opacity: 1;\n  transition: opacity 0.3s;\n}\n\n.sidebar.closed .sidebar-header h2 {\n  opacity: 0;\n  width: 0;\n  overflow: hidden;\n}\n\n.sidebar-toggle {\n  background: rgba(255, 255, 255, 0.1);\n  border: none;\n  color: white;\n  width: 32px;\n  height: 32px;\n  border-radius: 6px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s;\n  font-size: 14px;\n}\n\n.sidebar-toggle:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.sidebar-nav {\n  flex: 1;\n  padding: 20px 0;\n  overflow-y: auto;\n}\n\n.sidebar-nav ul {\n  list-style: none;\n  padding: 0;\n}\n\n.sidebar-nav li {\n  margin: 4px 12px;\n}\n\n.nav-link {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  color: rgba(255, 255, 255, 0.8);\n  text-decoration: none;\n  border-radius: 8px;\n  transition: all 0.2s;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.nav-link:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n}\n\n.nav-link.active {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n}\n\n.nav-icon {\n  font-size: 20px;\n  width: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.nav-label {\n  white-space: nowrap;\n  opacity: 1;\n  transition: opacity 0.3s;\n}\n\n.sidebar.closed .nav-label {\n  opacity: 0;\n  width: 0;\n  overflow: hidden;\n}\n\n.sidebar-footer {\n  padding: 20px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.logout-button {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  background: rgba(255, 255, 255, 0.1);\n  border: none;\n  border-radius: 8px;\n  color: white;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.logout-button:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.sidebar.closed .logout-button span:not(:first-child) {\n  opacity: 0;\n  width: 0;\n  overflow: hidden;\n}\n\n.dashboard-main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.dashboard-header {\n  background: white;\n  padding: 24px 32px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.dashboard-header h1 {\n  font-size: 24px;\n  font-weight: 700;\n  color: #1a202c;\n}\n\n.dashboard-content {\n  flex: 1;\n  padding: 32px;\n  overflow-y: auto;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
